export default function ({ store }) {
    store.dispatch('closeOnSmallDevices')
}